import axios from 'axios'
import Template from 'interfaces/Template'

const API_URL = process.env.REACT_APP_API_URL + '/templates'

const headers = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'x-tenant-id': `${localStorage.getItem('tenant-id')}`,
})

const parseFilter = (filter: unknown) => {
    if (filter == null || filter === '') return {}
    if (typeof filter === 'string') {
        try {
            return JSON.parse(filter)
        } catch {
            return {}
        }
    }
    return {...(filter as object)}
}

const getTemplates = async (
    filter: unknown,
    pagination?: { page: number; pageSize: number }
) => {
    const parsed = parseFilter(filter)
    if (pagination?.page != null && pagination?.pageSize != null) {
        const page = Math.max(1, pagination.page)
        const pageSize = Math.max(1, pagination.pageSize)
        parsed.limit = pageSize
        parsed.skip = (page - 1) * pageSize
    }
    const qs = encodeURIComponent(JSON.stringify(parsed))
    return axios
        .get(API_URL + '?filter=' + qs, { headers: headers() })
        .then((response) => response.data)
}

const countTemplates = async (filter: unknown) => {
    const parsed = parseFilter(filter)
    const where = parsed.where !== undefined ? parsed.where : {}
    const qs = encodeURIComponent(JSON.stringify(where))
    return axios
        .get(API_URL + '/count?where=' + qs, { headers: headers() })
        .then((response) => {
            const data = response.data
            return typeof data === 'object' && data !== null && 'count' in data
                ? data.count
                : data
        })
}

const getTemplate = async (id: string) => {
    return axios
        .get(API_URL + '/' + id, { headers: headers() })
        .then((response) => response.data)
}

const saveTemplate = async (template: Template) => {
    return axios
        .post(API_URL, template, { headers: headers() })
        .then((response) => response.data)
}

const patchTemplate = async (id: string, template: Template) => {
    return axios
        .patch(API_URL + '/' + id, template, { headers: headers() })
        .then((response) => response.data)
}

const deleteTemplate = async (id: string) => {
    return axios
        .delete(API_URL + '/' + id, { headers: headers() })
        .then((response) => response.data)
}

const exportedMethods = {
    getTemplate,
    getTemplates,
    countTemplates,
    patchTemplate,
    saveTemplate,
    deleteTemplate,
}

export default exportedMethods
